module.exports = __webpack_public_path__ + "static/media/renovation-photo-product.8d7e1a5d.jpg";